<template>
<div class="chapter">
<div class="inner_page">
<p class="title_center"><a id="page_iii"><span class="bold">Battleground Europe</span></a></p><a id="page_iii">
<h1 class="title"><span class="bold">The Dunkirk Perimeter and Evacuation 1940</span></h1>
<p class="subtitle"><em class="italic">France and Flanders Campaign</em></p>
<p class="author">Jerry Murland</p>
<p class="edit"><em class="italic">Series Editor</em></p>
<p class="edit1">Nigel Cave</p>
<div class="pub"><img alt="Image" src="images/logo.jpg"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?4dccd150